import values from 'ramda/src/values';
import { ALWAYS_ABLE_TO_SET_AS_DEFAULT_TYPES, CREATABLE_PAYMENT_INSTRUMENT_TYPES, DEFAULT_UNKNOWN_PAYMENT_METHOD_TYPE_SORT_ORDER, EDITABLE_PAYMENT_INSTRUMENT_TYPES, PAYMENT_INSTRUMENT_ALWAYS_REQUIRED_ADDRESS, PAYMENT_INSTRUMENT_NEVER_REQUIRED_ADDRESS, PAYMENT_METHOD_TYPE_SORT_ORDER, READ_ONLY_PAYMENT_INSTRUMENT_TYPES_EXCEPTIONS, SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES, SUPPORTED_PAYMENT_INSTRUMENT_TYPES, AUTO_PAY_SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../../components/customer/ewallet/ewallet.constants';
var EMPTY_ARRAY = [];
export var getDefaultPaymentMethodFromPaymentInstruments = function getDefaultPaymentMethodFromPaymentInstruments(customerPaymentInstruments) {
  var defaultPaymentMethod = customerPaymentInstruments.find(function (currentInstrument) {
    return currentInstrument.Default;
  });
  if (!defaultPaymentMethod || !defaultPaymentMethod.Id) {
    defaultPaymentMethod = customerPaymentInstruments[0];
  }
  return defaultPaymentMethod;
};
export var getDefaultPaymentMethodFromPaymentInstrumentsWithAutoPay = function getDefaultPaymentMethodFromPaymentInstrumentsWithAutoPay(customerPaymentInstruments) {
  var defaultPaymentMethodWithConvergentAccounts = customerPaymentInstruments.find(function (currentPaymentInstrument) {
    return (currentPaymentInstrument.ConvergentBillerPaymentInstrumentAccounts || EMPTY_ARRAY).some(function (convergentBillerPaymentInstrumentAccount) {
      return convergentBillerPaymentInstrumentAccount.AutoPay;
    });
  });
  if (!defaultPaymentMethodWithConvergentAccounts) {
    defaultPaymentMethodWithConvergentAccounts = getDefaultPaymentMethodFromPaymentInstruments(customerPaymentInstruments);
  }
  return defaultPaymentMethodWithConvergentAccounts;
};
export var isSupportedPaymentInstrumentType = function isSupportedPaymentInstrumentType(type) {
  return values(SUPPORTED_PAYMENT_INSTRUMENT_TYPES).indexOf(String(type)) > -1;
};
export var isSupportedOTTPaymentInstrumentType = function isSupportedOTTPaymentInstrumentType(type) {
  return values(SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES).indexOf(String(type)) > -1;
};
export var isCreatablePaymentInstrumentType = function isCreatablePaymentInstrumentType(type) {
  return values(CREATABLE_PAYMENT_INSTRUMENT_TYPES).indexOf(String(type)) > -1;
};
export var isEditablePaymentInstrumentType = function isEditablePaymentInstrumentType(type) {
  return values(EDITABLE_PAYMENT_INSTRUMENT_TYPES).indexOf(String(type)) > -1;
};
export var isAddressAlwaysRequiredForPaymentInstrumentType = function isAddressAlwaysRequiredForPaymentInstrumentType(type) {
  return values(PAYMENT_INSTRUMENT_ALWAYS_REQUIRED_ADDRESS).indexOf(String(type)) > -1;
};
export var isAddressNeverRequiredForPaymentInstrumentType = function isAddressNeverRequiredForPaymentInstrumentType(type) {
  return values(PAYMENT_INSTRUMENT_NEVER_REQUIRED_ADDRESS).indexOf(String(type)) > -1;
};
export var isAlwaysAbleToBeSetAsDefaultType = function isAlwaysAbleToBeSetAsDefaultType(type) {
  return values(ALWAYS_ABLE_TO_SET_AS_DEFAULT_TYPES).indexOf(String(type)) > -1;
};
export var isReadOnlyException = function isReadOnlyException(type) {
  return values(READ_ONLY_PAYMENT_INSTRUMENT_TYPES_EXCEPTIONS).indexOf(String(type)) !== -1;
};
export var isLockedPaymentInstrument = function isLockedPaymentInstrument(paymentMethod) {
  return Boolean(paymentMethod.Locked);
};
export var isAutoPaySupportedPaymentInstrumentType = function isAutoPaySupportedPaymentInstrumentType(type) {
  return values(AUTO_PAY_SUPPORTED_PAYMENT_INSTRUMENT_TYPES).indexOf(String(type)) > -1;
};
var _paymentMethodTypeSortOrderLookup;
var getPaymentMethodTypeSortOrderLookup = function getPaymentMethodTypeSortOrderLookup() {
  if (!_paymentMethodTypeSortOrderLookup) {
    _paymentMethodTypeSortOrderLookup = PAYMENT_METHOD_TYPE_SORT_ORDER.reduce(function (lookup, paymentMethod, index) {
      lookup[paymentMethod] = index;
      return lookup;
    }, {});
  }
  return _paymentMethodTypeSortOrderLookup;
};
export var getPaymentMethodTypeSortOrder = function getPaymentMethodTypeSortOrder(methodType) {
  var sortOrder = getPaymentMethodTypeSortOrderLookup()[methodType.toString()];
  if (isNaN(sortOrder)) {
    return DEFAULT_UNKNOWN_PAYMENT_METHOD_TYPE_SORT_ORDER;
  }
  return sortOrder;
};

/**
 * This method is to fix the data deficiencies returned from the API
 * For example, in Stored Value Account, when initial amount and current balance have zero value
 * the property is simply omitted
 * @param paymentInstrument
 */
export var fixPaymentInstrumentData = function fixPaymentInstrumentData(paymentInstrument) {
  if (!paymentInstrument) {
    return paymentInstrument;
  }
  if (paymentInstrument.GiftCard && isNaN(paymentInstrument.GiftCard.Balance)) {
    paymentInstrument.GiftCard.Balance = 0;
  }
  if (paymentInstrument.StoredValueAccount) {
    var sva = paymentInstrument.StoredValueAccount;
    if (isNaN(sva.Balance)) {
      sva.Balance = 0;
    }
    if (isNaN(sva.InitialAmount)) {
      sva.InitialAmount = 0;
    }
  }
  return paymentInstrument;
};